/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_ProviderInputs */

const en_admin_payments_provider = /** @type {(inputs: Admin_Payments_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Admin_Payments_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_provider = /** @type {((inputs?: Admin_Payments_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_provider(inputs)
});
export { admin_payments_provider as "admin.payments.provider" }